import payload from '@app/payload';
import H from '@utils/helpers';

export function getPlanSelectionConfig(selectedPlan: any) {
  const disablePlanChoice = H.getUrlParam('disablePlanChoice') === 'true';
  const displayPlansParam = H.getUrlParam('displayPlans');
  let visiblePlans = payload.plans || [];
  let isInteractionDisabled = disablePlanChoice;

  if (displayPlansParam !== null) {
    if (displayPlansParam === 'false') {
      visiblePlans = selectedPlan ? [selectedPlan] : visiblePlans.slice(0, 1);
      isInteractionDisabled = true;
    } else {
      const allowedIds = displayPlansParam.split(',').map((id) => id.trim()).filter(Boolean);
      const filtered = visiblePlans.filter((plan: any) => allowedIds.includes(String(plan.id)));

      if (filtered.length > 0) {
        visiblePlans = filtered;
      } else {
        visiblePlans = selectedPlan ? [selectedPlan] : [];
        isInteractionDisabled = true;
      }
    }
  }

  return {
    visiblePlans,
    isInteractionDisabled,
  };
}
